(() => {
  if (window.RNFTitleMotion) { window.RNFTitleMotion.mount(document); return; }
  const NS = 'http://www.w3.org/2000/svg';
  const SELECTOR = '[data-rnf-motion-title]';
  const MOTION = Object.freeze({
    referenceFont: 80,
    referenceText: 946,
    travelMs: 2100,
    closingMs: 800,
    windMs: 923.79,
    secondaryWindMs: 594.53,
    gapEm: .05,
    formationEm: .31,
    formationLeadEm: .35,
    tileEm: .047,
    initialLeadEm: -.25,
    speedEmMs: .00875,
    multilineTimeScale: 1.75,
    birthMs: 240,
    fadeInMs: 90,
    handoffMs: 34,
    exitMinMs: 320,
    exitGutterEm: .2,
    rowPhase: .30,
    columnPhase: .785,
    travelSamples: [0, 131.98, 273.36, 417.13, 555.77, 681.87, 788.83, 872.33, 930.34, 963.92, 977.50, 978.82],
    movingSizes: [.10,.15,.28,.45,.63,.81,.94,1,1,1],
    finalSizes: [1,1,1,.94,.80,.63,.44,.27,.14,.10]
  });
  const controllers = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const startupReady = new Promise(resolve=>{
    if(document.readyState==='complete'){resolve();return;}
    let timer;
    const ready=()=>{clearTimeout(timer);window.removeEventListener('load',ready);resolve();};
    window.addEventListener('load',ready,{once:true});
    timer=setTimeout(ready,900);
  });
  let serial = 0;
  const clamp = (x, a=0, b=1) => Math.min(b, Math.max(a, x));
  const lerp = (a,b,t) => a+(b-a)*t;
  const smooth = x => { x=clamp(x); return x*x*(3-2*x); };
  const svg = (tag,attrs={}) => {
    const e=document.createElementNS(NS,tag);
    for (const [k,v] of Object.entries(attrs)) e.setAttribute(k,v);
    return e;
  };
  const cells=[];
  for(let r=0;r<4;r++) for(let c=0;c<10;c++) if((r+c)%2===0) cells.push({r,c});
  function flagGeometry(cell,morph) {
    const {r,c}=cell;
    const a=MOTION.movingSizes[c];
    const b=MOTION.finalSizes[c];
    const size=lerp(a,b,morph);
    const cx=c*21.127+(1.5-r)*8.738+10.5;
    const cy=(r-1.5)*18.20;
    const ay=6.8273+.22296*(c-4.5)-.52520*(r-1.5)+.34647*(r-1.5)**2+.00414*(c-4.5)*(r-1.5);
    return [[-1,-1],[1,-1],[1,1],[-1,1]].map(([u,v])=>{
      const x=cx+u*10.5*size-v*4.32*size;
      const y=cy+v*9*size;
      const column=c+u*.5*size,row=r+v*.5*size;
      const p=column*MOTION.columnPhase+row*MOTION.rowPhase-2.47;
      const q=column*1.64+row*.225-2.475;
      const a=column*.676-row*.130-2.619;
      const b=column*1.64+row*.225-.970;
      return {x,y,xc:2.925*Math.cos(a),xs:-2.925*Math.sin(a),xqc:.171*Math.cos(b),xqs:-.171*Math.sin(b),ys:ay*Math.cos(p),yc:ay*Math.sin(p),yqs:1.83*Math.cos(q),yqc:1.83*Math.sin(q)};
    });
  }
  cells.forEach(cell=>{cell.moving=flagGeometry(cell,0);cell.final=flagGeometry(cell,1);});
  function flagPoints(cell,phase,amplitude,morph,secondaryPhase=0,tileScale=1,wind) {
    const geometry=morph===0?cell.moving:morph===1?cell.final:flagGeometry(cell,morph);
    const [sin,cos,secondarySin,secondaryCos]=wind||[Math.sin(phase),Math.cos(phase),Math.sin(secondaryPhase),Math.cos(secondaryPhase)];
    const points=geometry.map(p=>{
      const x=p.x+amplitude*(cos*p.xc+sin*p.xs+secondaryCos*p.xqc+secondarySin*p.xqs);
      const y=p.y+amplitude*(sin*p.ys+cos*p.yc+secondarySin*p.yqs+secondaryCos*p.yqc);
      return [x,y];
    });
    if(tileScale===1)return points;
    const center=points.reduce((sum,p)=>[sum[0]+p[0]/4,sum[1]+p[1]/4],[0,0]);
    return points.map(p=>[center[0]+(p[0]-center[0])*tileScale,center[1]+(p[1]-center[1])*tileScale]);
  }
  const finalPoints=cells.flatMap(cell=>flagPoints(cell,0,0,1));
  const bounds={left:Math.min(...finalPoints.map(p=>p[0])),right:Math.max(...finalPoints.map(p=>p[0])),top:Math.min(...finalPoints.map(p=>p[1])),bottom:Math.max(...finalPoints.map(p=>p[1]))};
  bounds.width=bounds.right-bounds.left;
  bounds.height=bounds.bottom-bounds.top;
  const movingRight=Math.max(...cells.map(({r,c})=>c*21.127+(1.5-r)*8.738+10.5+14.82*MOTION.movingSizes[c]+3.096));
  const polygon = points => 'M'+points.map(p=>p.map(n=>n.toFixed(3)).join(',')).join('L')+'Z';
  function staticFlag() {
    const el=svg('svg',{viewBox:`${bounds.left} ${bounds.top} ${bounds.width} ${bounds.height}`,fill:'currentColor','aria-hidden':'true',focusable:'false'});
    cells.forEach(cell=>el.append(svg('path',{d:polygon(flagPoints(cell,0,0,1))})));
    return el;
  }
  function travel(p) {
    p=clamp(p);
    const times=[0,200,400,600,800,1000,1200,1400,1600,1800,2000,2100];
    let i=0;
    while(i<times.length-2 && p*2100>times[i+1]) i++;
    const values=MOTION.travelSamples;
    const t=(p*2100-times[i])/(times[i+1]-times[i]);
    const y0=values[i], y1=values[i+1];
    const slope=k=> k===0 ? (values[1]-values[0])/(times[1]-times[0]) : k===values.length-1 ? 0 : (values[k+1]-values[k-1])/(times[k+1]-times[k-1]);
    const dt=times[i+1]-times[i];
    const v=(2*t*t*t-3*t*t+1)*y0+(t*t*t-2*t*t+t)*dt*slope(i)+(-2*t*t*t+3*t*t)*y1+(t*t*t-t*t)*dt*slope(i+1);
    return v/values.at(-1);
  }
  function textRects(root,base) {
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    const result=[];
    const range=document.createRange();
    let node;
    while((node=walker.nextNode())) {
      if(node.parentElement.closest('[data-rnf-motion-slot]')) continue;
      const words=node.data.matchAll(/\S+/gu);
      for(const word of words) {
        range.setStart(node,word.index);range.setEnd(node,word.index+word[0].length);
        for(const rect of range.getClientRects()) if(rect.width>.01) result.push({left:rect.left-base.left,right:rect.right-base.left,top:rect.top-base.top,bottom:rect.bottom-base.top});
      }
    }
    const rows=[];
    result.sort((a,b)=>a.top-b.top||a.left-b.left).forEach(rect=>{
      let row=rows.find(x=>Math.abs(x.top-rect.top)<Math.max(2,(rect.bottom-rect.top)*.22));
      if(!row) {row={left:rect.left,right:rect.right,top:rect.top,bottom:rect.bottom};rows.push(row);}
      else {row.left=Math.min(row.left,rect.left);row.right=Math.max(row.right,rect.right);row.top=Math.min(row.top,rect.top);row.bottom=Math.max(row.bottom,rect.bottom);}
    });
    return rows.sort((a,b)=>a.top-b.top);
  }
  function lastUnit(source,slot,suffixOnly=false) {
    source.querySelectorAll('.rnf-motion-tail,.rnf-motion-end').forEach(node=>node.replaceWith(...node.childNodes));
    slot.remove();
    const records=[];
    let text='';
    const collect=node=>{
      if(node.nodeType===Node.TEXT_NODE) {records.push({node,start:text.length,end:text.length+node.data.length});text+=node.data;}
      else if(node.nodeName==='BR') text+='\n';
      else for(const child of node.childNodes)collect(child);
    };
    collect(source);
    const word=text.match(/\S+(?=\s*$)/u);
    if(!word) {source.append(slot);return null;}
    let start=word.index;
    const end=start+word[0].length;
    if(suffixOnly) {
      const characters=typeof Intl.Segmenter==='function'?[...new Intl.Segmenter(undefined,{granularity:'grapheme'}).segment(word[0])].map(x=>x.segment):Array.from(word[0]);
      start=end-characters.slice(-3).join('').length;
    }
    const first=records.find(x=>start>=x.start&&start<x.end);
    const last=records.find(x=>end>x.start&&end<=x.end);
    if(!first||!last) {source.append(slot);return null;}
    const middle=document.createRange();middle.setStart(first.node,start-first.start);middle.setEnd(last.node,end-last.start);
    const unitRoot=middle.commonAncestorContainer.nodeType===Node.TEXT_NODE?middle.commonAncestorContainer.parentNode:middle.commonAncestorContainer;
    const before=document.createRange();before.selectNodeContents(unitRoot);before.setEnd(first.node,start-first.start);
    const after=document.createRange();after.selectNodeContents(unitRoot);after.setStart(last.node,end-last.start);
    const contextualClone=range=>{
      let fragment=range.cloneContents();
      let ancestor=range.commonAncestorContainer;
      if(ancestor.nodeType===Node.TEXT_NODE)ancestor=ancestor.parentNode;
      while(ancestor&&ancestor!==unitRoot){
        const wrapper=ancestor.cloneNode(false);wrapper.append(fragment);
        fragment=document.createDocumentFragment();fragment.append(wrapper);
        ancestor=ancestor.parentNode;
      }
      return fragment;
    };
    const prefix=contextualClone(before),wordNodes=contextualClone(middle),suffix=contextualClone(after);
    const tail=document.createElement('span');tail.className=suffixOnly?'rnf-motion-end':'rnf-motion-tail';
    tail.append(wordNodes,slot);
    unitRoot.replaceChildren(prefix,...(suffixOnly?[document.createElement('wbr')]:[]),tail,suffix);
    [...source.querySelectorAll('strong,em,b,i,a,span')].reverse().forEach(node=>{if(!node.textContent&&!node.querySelector('br,img,svg,[data-rnf-motion-slot]')&&node!==slot)node.remove();});
    return tail;
  }
  class Title {
    constructor(heading) {
      this.heading=heading;
      this.source=heading.querySelector('[data-rnf-motion-source]');
      this.slot=heading.querySelector('[data-rnf-motion-slot]');
      this.id='rnf-motion-'+(++serial);
      this.played=false;
      this.dead=false;
      this.raf=0;
      this.layoutRaf=0;
      this.startIdle=0;
      this.startRaf=0;
      this.startQueued=false;
      this.inView=false;
      this.state='initial';
      this.fontReady=false;
      this.nearby=typeof IntersectionObserver!=='function';
      this.lastWidth=0;
      this.slot.replaceChildren(staticFlag());
      this.resize=new ResizeObserver(entries=>{
        const width=entries[0].contentRect.width;
        if(Math.abs(width-this.lastWidth)>.5) {this.lastWidth=width;this.schedule();}
      });
      this.resize.observe(heading);
      this.mutation=new MutationObserver(()=>this.schedule());
      this.watchSource();
      this.attributes=new MutationObserver(()=>{
        const signature=this.typography();
        if(signature!==this.fontSignature){this.fontSignature=signature;this.schedule();}
      });
      this.attributes.observe(heading,{attributes:true,attributeFilter:['class','style','dir']});
      this.fontChange=event=>{
        if(this.fontReady&&event.fontfaces.some(face=>getComputedStyle(this.heading).fontFamily.toLowerCase().includes(face.family.replace(/["']/g,'').toLowerCase()))) this.schedule();
      };
      document.fonts?.addEventListener('loadingdone',this.fontChange);
      if(!this.nearby){
        this.preparation=new IntersectionObserver(entries=>{
          if(!entries.some(entry=>entry.isIntersecting))return;
          this.nearby=true;this.preparation.disconnect();
          if(this.fontReady)this.safe(()=>this.layout(false));
        },{rootMargin:'250px 0px'});
        this.preparation.observe(heading);
      }
      this.readyFonts=document.fonts?.ready||Promise.resolve();
      this.readyFonts.then(()=>{if(!this.dead){this.fontReady=true;if(this.nearby)this.safe(()=>this.layout(false));}}).catch(()=>this.failOpen());
    }
    schedule() {
      if(this.dead||!this.fontReady||this.layoutRaf||(!this.nearby&&!this.played)) return;
      if(this.state==='running') this.finish();
      this.layoutRaf=requestAnimationFrame(()=>{this.layoutRaf=0;this.safe(()=>this.layout(this.played));});
    }
    safe(fn) {try {fn();} catch(error) {this.failOpen();}}
    releaseBoot() {clearTimeout(this.heading.__rnfMotionBootTimer);delete this.heading.__rnfMotionBootTimer;this.heading.__rnfMotionBootObserver?.disconnect();delete this.heading.__rnfMotionBootObserver;this.heading.removeAttribute('data-rnf-motion-pending');}
    watchSource() {this.mutation.observe(this.source,{childList:true,characterData:true,attributes:true,attributeFilter:['class','style'],subtree:true});}
    typography() {
      const style=getComputedStyle(this.heading);
      return [style.fontFamily,style.fontSize,style.fontWeight,style.fontStyle,style.lineHeight,style.letterSpacing,style.fontFeatureSettings,style.fontVariationSettings,style.textTransform,style.direction].join('|');
    }
    fitTail() {
      this.mutation.disconnect();
      this.slot=this.source.querySelector('[data-rnf-motion-slot]')||document.createElement('span');
      this.slot.className='rnf-motion-slot';
      this.slot.setAttribute('data-rnf-motion-slot','');
      this.slot.setAttribute('aria-hidden','true');
      if(!this.slot.querySelector('svg'))this.slot.replaceChildren(staticFlag());
      this.source.querySelectorAll('[data-rnf-motion-slot]').forEach(slot=>{if(slot!==this.slot)slot.remove();});
      this.heading.style.removeProperty('--rnf-flag-width');
      this.source.style.removeProperty('overflow-wrap');
      const tail=lastUnit(this.source,this.slot);
      const headingWidth=this.heading.getBoundingClientRect().width;
      const font=parseFloat(getComputedStyle(this.heading).fontSize);
      const flagWidth=bounds.width/80*font;
      this.heading.style.setProperty('--rnf-flag-width',flagWidth+'px');
      if(tail) {
        const range=document.createRange();range.selectNodeContents(tail);range.setEndBefore(this.slot);
        const word=range.getBoundingClientRect().width;
        const fitted=Math.min(flagWidth,headingWidth-word-font*MOTION.gapEm-.5);
        if(fitted>=font*.35) this.heading.style.setProperty('--rnf-flag-width',fitted+'px');
        else {lastUnit(this.source,this.slot,true);this.source.style.overflowWrap='anywhere';this.heading.style.setProperty('--rnf-flag-width',Math.min(flagWidth,headingWidth*.25)+'px');}
      }
      this.watchSource();
    }
    layout(finalOnly=false) {
      if(this.dead||!this.heading.isConnected) return;
      cancelAnimationFrame(this.raf);this.raf=0;
      this.observer?.disconnect();
      this.stage?.remove();this.stage=null;this.visual=null;
      this.heading.removeAttribute('data-rnf-motion-state');
      this.fitTail();
      const box=this.heading.getBoundingClientRect();
      if(box.width<1||box.height<1) return;
      this.lastWidth=box.width;
      const style=getComputedStyle(this.heading);
      this.fontSignature=this.typography();
      this.em=parseFloat(style.fontSize);
      this.lineHeight=parseFloat(style.lineHeight)||this.em*1.3;
      this.width=box.width;this.height=box.height;
      this.rows=textRects(this.source,box);
      if(!this.rows.length) return;
      const probe=document.createElement('span');
      probe.style.cssText='position:absolute;top:0;left:0;display:block;font:inherit;line-height:inherit;visibility:hidden;pointer-events:none';
      probe.textContent='M';this.heading.append(probe);
      const probeRange=document.createRange();probeRange.selectNodeContents(probe);
      const firstTop=probeRange.getBoundingClientRect().top-box.top;
      probe.remove();
      this.rows.forEach((row,i)=>{
        row.y=row.top-firstTop;
        row.h=this.lineHeight;
        row.center=row.y+this.lineHeight/2;
        row.width=row.right-row.left;
      });
      const slot=this.slot.getBoundingClientRect();
      this.finalFlag={x:slot.left-box.left,y:slot.top-box.top,w:slot.width,h:slot.height};
      this.heading.dataset.rnfMotionRows=String(this.rows.length);
      const fixed=finalOnly||this.played||this.heading.hasAttribute('data-rnf-motion-boot-expired')||reduced.matches||window.Shopify?.designMode||typeof IntersectionObserver!=='function'||!window.CSS?.supports?.('clip-path','path("M0 0Z")');
      if(fixed) {this.played=true;this.state='done';this.heading.dataset.rnfMotionState='done';this.releaseBoot();return;}
      this.makeStage(style);
      this.makeTimeline();
      this.state='ready';this.heading.dataset.rnfMotionState='ready';
      this.render(0);
      this.releaseBoot();
      this.observer=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          this.inView=entry.isIntersecting;
          if(entry.isIntersecting&&entry.intersectionRatio>=.3)this.start();
          else if(!entry.isIntersecting&&this.state==='running')this.finish();
        });
      },{threshold:[0,.3]});
      this.observer.observe(this.heading);
    }
    makeStage(style) {
      const stage=document.createElement('span');
      stage.className='rnf-motion-stage';
      stage.setAttribute('aria-hidden','true');stage.setAttribute('inert','');
      this.masks=this.rows.map(()=>({solidWidth:0,piecesPath:'',mode:'empty'}));
      const visual=document.createElement('div');
      visual.className=this.heading.className+' rnf-motion-visual';
      visual.append(this.source.cloneNode(true));
      visual.setAttribute('inert','');visual.setAttribute('aria-hidden','true');
      visual.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(node=>node.setAttribute('tabindex','-1'));
      visual.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));
      visual.querySelectorAll('svg').forEach(node=>node.remove());
      for(const name of ['fontFamily','fontSize','fontWeight','fontStyle','fontStretch','lineHeight','letterSpacing','wordSpacing','fontFeatureSettings','fontVariationSettings','textTransform','direction','color']) visual.style[name]=style[name];
      visual.style.textAlign='center';
      visual.style.setProperty('--rnf-flag-width',this.finalFlag.w+'px');
      stage.append(visual);
      const flag=svg('svg',{class:'rnf-motion-flag',viewBox:`0 0 ${this.width} ${this.height}`,'aria-hidden':'true',focusable:'false'});
      this.flagGroup=svg('g',{fill:'currentColor'});
      this.flagPaths=[svg('path')];this.flagGroup.append(this.flagPaths[0]);
      flag.append(this.flagGroup);stage.append(flag);
      this.heading.append(stage);this.stage=stage;this.visual=visual;this.lastClip=null;
      this.heading.dataset.rnfMotionRenderer='html-clip';
    }
    makeTimeline() {
      this.timeline=[];
      this.writeTimeScale=this.rows.length>1?MOTION.multilineTimeScale:1;
      let now=0;
      const initialLead=MOTION.initialLeadEm*this.em;
      this.rows.forEach((row,i)=>{
        const last=i===this.rows.length-1;
        const inkFrom=row.left+initialLead;
        const inkTo=row.right+MOTION.gapEm*this.em;
        const reach=(movingRight-bounds.left)*this.finalFlag.w/bounds.width;
        const safeEnd=this.width-MOTION.exitGutterEm*this.em-reach;
        const to={x:last?this.finalFlag.x:Math.min(inkTo,safeEnd),y:row.center};
        const from={x:last?inkFrom:Math.min(inkFrom,to.x),y:row.center};
        const distance=to.x-from.x;
        let duration=last?MOTION.travelMs*(distance/this.em)/(MOTION.referenceText/80+.3)*this.writeTimeScale:0;
        let exit;
        if(!last){
          const speed=this.em*MOTION.speedEmMs/this.writeTimeScale;
          const preferred=this.em*MOTION.speedEmMs*MOTION.exitMinMs/2;
          const x=Math.max(from.x,to.x-preferred);
          const cruiseMs=(x-from.x)/speed;
          const exitMs=Math.max(MOTION.exitMinMs*this.writeTimeScale,2*(to.x-x)/speed);
          const inkX=inkFrom+x-from.x;
          const inkSpeed=Math.min(speed,2*(inkTo-inkX)/exitMs);
          exit={start:now+cruiseMs,end:now+cruiseMs+exitMs,x,inkX,inkTo,inkSpeed};
          duration=cruiseMs+exitMs;
        }
        this.timeline.push({type:'write',row:i,start:now,end:now+duration,from,to,last,...(exit?{exit,inkFrom}:{} )});
        now+=duration;
        if(!last) {
          const next=this.rows[i+1];
          const nextLast=i+1===this.rows.length-1;
          const nextStart={x:nextLast?next.left+initialLead:Math.min(next.left+initialLead,next.right+MOTION.gapEm*this.em,safeEnd),y:next.center};
          this.timeline.push({type:'handoff',row:i,start:now,end:now+MOTION.handoffMs,from:to,to:nextStart});now+=MOTION.handoffMs;
        }
      });
      this.arrival=now;
      this.duration=now+MOTION.closingMs;
    }
    start() {
      if(this.dead||this.played||this.state!=='ready'||this.startQueued) return;
      this.startQueued=true;
      startupReady.then(()=>{
        if(this.dead||this.played||this.state!=='ready'){this.startQueued=false;return;}
        const run=()=>{
          this.startIdle=0;this.startRaf=0;this.startQueued=false;
          if(!this.dead&&!this.played&&this.state==='ready'&&this.inView&&!document.hidden)this.safe(()=>this.play());
        };
        if(typeof window.requestIdleCallback==='function')this.startIdle=window.requestIdleCallback(run,{timeout:400});
        else this.startRaf=requestAnimationFrame(run);
      });
    }
    play() {
      this.played=true;this.state='running';
      this.heading.dataset.rnfMotionState='running';
      this.started=performance.now();
      let previous=this.started;
      let elapsed=0;
      const tick=time=>{
        this.raf=0;
        if(this.dead||this.state!=='running') return;
        this.safe(()=>{
          elapsed+=Math.min(1000/30,Math.max(0,time-previous));
          previous=time;
          if(elapsed>=this.duration) {this.finish();return;}
          this.render(elapsed);
          this.raf=requestAnimationFrame(tick);
        });
      };
      this.raf=requestAnimationFrame(tick);
    }
    sampleMotion(elapsed) {
      const segment=this.timeline.find(s=>elapsed<=s.end)||this.timeline.at(-1);
      let pos;
      let opacity=1;
      let tileScale=1;
      let inkX;
      if(elapsed>=this.arrival) pos={x:this.finalFlag.x,y:this.rows.at(-1).center};
      else {
        const progress=clamp((elapsed-segment.start)/(segment.end-segment.start));
        pos={x:lerp(segment.from.x,segment.to.x,segment.last?travel(progress):progress),y:lerp(segment.from.y,segment.to.y,progress)};
        if(segment.type==='handoff'){opacity=0;tileScale=0;}
        else {
          if(segment.row>0)opacity*=smooth((elapsed-segment.start)/MOTION.fadeInMs);
          if(!segment.last){
            const exit=segment.exit;
            if(elapsed<exit.start){pos.x=segment.from.x+(elapsed-segment.start)*this.em*MOTION.speedEmMs/this.writeTimeScale;inkX=segment.inkFrom+(elapsed-segment.start)*this.em*MOTION.speedEmMs/this.writeTimeScale;}
            else {
              const u=clamp((elapsed-exit.start)/(exit.end-exit.start));
              const eased=1-(1-u)*(1-u);
              pos.x=lerp(exit.x,segment.to.x,eased);
              inkX=lerp(exit.inkX,exit.inkTo,smooth(u))+exit.inkSpeed*(exit.end-exit.start)*u*(1-u)*(1-u);
              const fade=1-smooth(u);
              tileScale=fade;
              opacity*=fade;
            }
          }
          tileScale*=smooth((elapsed-segment.start)/Math.min(MOTION.birthMs,segment.end-segment.start));
        }
      }
      const close=clamp((elapsed-this.arrival)/MOTION.closingMs);
      const morph=Math.pow(smooth(close),.78);
      const amplitude=1-morph;
      const phase=elapsed/MOTION.windMs*Math.PI*2;
      const secondaryPhase=elapsed/MOTION.secondaryWindMs*Math.PI*2;
      return {segment,pos,opacity,morph,amplitude,phase,secondaryPhase,tileScale,inkX:inkX??pos.x};
    }
    render(elapsed) {
      const {segment,pos,opacity,morph,amplitude,phase,secondaryPhase,tileScale,inkX}=this.sampleMotion(elapsed);
      const scale=this.finalFlag.w/bounds.width;
      const center=(bounds.top+bounds.bottom)/2;
      const baselineOffset=this.finalFlag.y+this.finalFlag.h/2-this.rows.at(-1).center;
      this.flagGroup.setAttribute('transform',`translate(${(pos.x-bounds.left*scale).toFixed(3)} ${(pos.y+baselineOffset-center*scale).toFixed(3)}) scale(${scale})`);
      this.flagGroup.setAttribute('opacity',opacity.toFixed(4));
      if(opacity>0){
        const wind=[Math.sin(phase),Math.cos(phase),Math.sin(secondaryPhase),Math.cos(secondaryPhase)];
        this.flagPaths[0].setAttribute('d',cells.map(cell=>polygon(flagPoints(cell,phase,amplitude,morph,secondaryPhase,tileScale,wind))).join(''));
      }
      for(let i=0;i<this.rows.length;i++) {
        const row=this.rows[i],parts=this.masks[i];
        const mode=elapsed<=0?'empty':i<segment.row||(i===segment.row&&segment.type==='handoff')||elapsed>=this.arrival?'full':i===segment.row&&segment.type==='write'?'active':'empty';
        if(mode!=='active') {
          if(parts.mode!==mode){parts.solidWidth=mode==='full'?this.width:0;parts.piecesPath='';parts.mode=mode;}
          continue;
        }
        parts.mode='active';
        const front=inkX+MOTION.formationLeadEm*this.em;
        const band=MOTION.formationEm*this.em;
        const solid=Math.max(0,front-band);
        parts.solidWidth=Number(solid.toFixed(3));
        const unit=MOTION.tileEm*this.em;
        const start=Math.floor(solid/unit)*unit;
        let path='';
        for(let x=start;x<front+unit;x+=unit) for(let y=row.y;y<row.y+row.h;y+=unit) {
          const progress=clamp((front-x)/band);
          const stagger=Math.sin((y-row.y)/unit*.84+x/unit*.31+phase*.35)*.10;
          const size=clamp(progress*1.16+stagger);
          if(size<=.03) continue;
          const spread=(1-size)*unit*.72;
          const skew=(1-size)*unit*.7;
          const px=x+spread,py=y+(1-size)*unit*.3;
          const w=unit*(.12+.9*size),h=unit*(.13+.91*size);
          path+=`M${(px+skew).toFixed(2)},${py.toFixed(2)}h${w.toFixed(2)}l${(-skew).toFixed(2)},${h.toFixed(2)}h${(-w).toFixed(2)}Z`;
        }
        parts.piecesPath=path;
      }
      const clip=this.masks.map((parts,i)=>{
        const row=this.rows[i];
        return (parts.solidWidth>0?`M0,${row.y}H${parts.solidWidth}v${row.h}H0Z`:'')+parts.piecesPath;
      }).join('')||'M0 0Z';
      if(clip!==this.lastClip){
        const value=`path('${clip}')`;
        this.visual.style.clipPath=value;
        this.lastClip=clip;
      }
    }
    finish() {
      this.releaseBoot();
      if(this.startIdle)window.cancelIdleCallback?.(this.startIdle);
      cancelAnimationFrame(this.startRaf);this.startIdle=0;this.startRaf=0;this.startQueued=false;
      cancelAnimationFrame(this.raf);this.raf=0;
      this.observer?.disconnect();
      this.played=true;this.state='done';
      this.stage?.remove();this.stage=null;this.visual=null;
      this.heading.dataset.rnfMotionState='done';
      this.flagGroup=null;this.flagPaths=null;this.masks=null;this.timeline=null;
    }
    failOpen() {
      this.finish();
      this.heading.removeAttribute('data-rnf-motion-state');
      this.state='fallback';
    }
    destroy() {
      this.dead=true;this.finish();cancelAnimationFrame(this.layoutRaf);
      this.layoutRaf=0;
      this.resize.disconnect();this.mutation.disconnect();
      this.preparation?.disconnect();
      this.attributes.disconnect();
      document.fonts?.removeEventListener('loadingdone',this.fontChange);
      controllers.delete(this.heading);
    }
  }
  function mount(root) {
    const headings=[...(root.matches?.(SELECTOR)?[root]:[]),...root.querySelectorAll(SELECTOR)];
    headings.forEach(heading=>{
      if(controllers.has(heading)||!heading.querySelector('[data-rnf-motion-slot]')) return;
      let instance;
      try {instance=new Title(heading);controllers.set(heading,instance);} catch(error) {clearTimeout(heading.__rnfMotionBootTimer);heading.__rnfMotionBootObserver?.disconnect();delete heading.__rnfMotionBootObserver;heading.removeAttribute('data-rnf-motion-pending');heading.removeAttribute('data-rnf-motion-state');instance?.destroy();}
    });
  }
  const finishAll=()=>controllers.forEach(controller=>controller.finish());
  document.addEventListener('shopify:section:load',event=>mount(event.target));
  document.addEventListener('shopify:section:unload',event=>controllers.forEach((controller,heading)=>{if(event.target.contains(heading))controller.destroy();}));
  document.addEventListener('shopify:section:select',event=>controllers.forEach((controller,heading)=>{if(event.target.contains(heading))controller.finish();}));
  document.addEventListener('visibilitychange',()=>controllers.forEach(controller=>{
    if(document.hidden){if(controller.state==='running')controller.finish();}
    else if(controller.state==='ready'&&controller.inView)controller.start();
  }));
  reduced.addEventListener('change',finishAll);
  window.RNFTitleMotion={mount,parameters:MOTION,inspect:()=>[...controllers.values()].map(c=>({id:c.id,state:c.state,rows:c.rows?.map(x=>({...x})),flag:c.finalFlag,width:c.width,height:c.height,arrival:c.arrival,duration:c.duration,raf:!!c.raf,layoutRaf:!!c.layoutRaf,played:c.played}))};
  mount(document);
})();
